import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { MealItemFormModel } from '../../../app/data/models/mealItems/mealItemFormModel';
import api from '../../../app/api/api';
import { fetchMealItemListAsync } from './mealItemListSlice';

export const updateMealItemAsync = createAsyncThunk<
  void,
  { restaurantId: string; mealItemId: string; data: MealItemFormModel }
>('mealItems/update', async ({ restaurantId, mealItemId, data }, thunkApi) => {
  try {
    await api.MealItem.update(restaurantId, mealItemId, data);
    thunkApi.dispatch(fetchMealItemListAsync(restaurantId));
  } catch (error: unknown) {
    if (error instanceof Error) {
      return thunkApi.rejectWithValue({ error: error.message });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const updateMealItemSlice = createSlice({
  name: 'updateMealItem',
  initialState: { status: 'idle' },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateMealItemAsync.pending, (state) => {
      state.status = 'pendingUpdateMealItem';
    });
    builder.addCase(updateMealItemAsync.fulfilled, (state) => {
      state.status = 'idle';
    });
    builder.addCase(updateMealItemAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
